<div style="display: flex; justify-content: space-evenly">
    <div>
        <button mat-button (click)="changeMonth('previous')"> < </button>
    </div>
    <div style="display: flex;align-items: center;">{{month | translate}} {{year}}</div>
    <div>
        <button mat-button (click)="changeMonth('next')"> > </button>
    </div>
</div>
<mat-grid-list cols="7" rowHeight="1.4:1" [gutterSize]="-1">
    <mat-grid-tile>
        <div class="calendar-header" translate>Sun</div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="calendar-header" translate>Mon</div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="calendar-header" translate>Tue</div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="calendar-header" translate>Wed</div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="calendar-header" translate>Thu</div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="calendar-header" translate>Fri</div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="calendar-header" translate>Sat</div>
    </mat-grid-tile>
    <mat-grid-tile *ngFor="let date of calendarDates">
        <div class="calendar-day" (click)="dayClicked(date)" [ngClass]="{'today': date.isToday || (date.hasEvents && showBellIcon) , 'non-school-day': !date.hasSchool && !showBellIcon, 'has-events' : date.hasEvents && !showBellIcon, 'over-due-alert': showBellIcon && !date.hasSchool, 'show-bell-icon': (!date.hasSchool || date.hasEvents) && showBellIcon}">
            <div [ngClass]="{'not-current-month-day': !date.isCurrentMonth}" >{{date.day}}</div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
